import { useEffect, useState } from "react"
import imageOptimizer from "../services/imageOptimizer"

const SM = 640
const MD = 1200
const LG = 1920

const useOptimizedImages = (image, sm, md, lg, xlg) => {
  const [size, setSize] = useState()

  useEffect(() => {
    const handler = () => {
      if (window.innerWidth <= SM) {
        setSize(sm)
      } else if (window.innerWidth <= MD) {
        setSize(md)
      } else if (window.innerWidth <= LG) {
        setSize(lg)
      } else {
        setSize(xlg)
      }
    }
    handler()
    window.addEventListener("resize", handler)
    return () => window.removeEventListener("resize", handler)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const url = imageOptimizer(image, size)

  return url
}

export default useOptimizedImages
